import { Loader2 } from "lucide-react";

export function LoadingPage() {
  return (
    <div className="min-h-screen bg-surface-mute flex items-center justify-center">
      <div className="text-center space-y-6">
        <Loader2 className="h-12 w-12 animate-spin text-blue-600 mx-auto" />
        <div className="space-y-2">
          <h2 className="text-xl font-semibold text-ink">
            Loading Neztrack
          </h2>
          <p className="text-sm text-ink-3">
            Please wait while we set up your workspace...
          </p>
        </div>
      </div>
    </div>
  );
}
